import series from '@/api/series'

export default () => ({
  namespaced: true,

  state: {
    list: []
  },

  actions: {
    fetch (context, cached = true) {
      const { list } = context.state
      if (cached && list.length) {
        return Promise.resolve(list)
      }

      return series.fetch()
        .then(data => context.commit('fetch', data))
    }
  },

  mutations: {
    fetch (state, data) {
      state.list = data
    }
  }
})
